import { styled } from "styled-components";
const LegendItemWrapper = styled.li`
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-variant-numeric: tabular-nums;
  font-size: ${({ theme }) => theme.fontSize.default}px;
  line-height: ${({ theme }) => theme.lineHeight.default};
  display: flex;
  margin-bottom: 4px;
`;
const LegendIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 16px;
  margin-right: 8px;
  font-size: 16px;
`;
const LegendIconCircle = styled.div`
  width: ${({ size }) => size === "small" ? 8 : 16}px;
  height: ${({ size }) => size === "small" ? 8 : 16}px;
  background-color: ${({ color }) => color || "transparent"};
  border: 1px solid
    ${({ size, theme }) => size ? theme.color.gray6 : "transparent"};
  box-sizing: border-box;
  font-variant-numeric: tabular-nums;
  border-radius: 50%;
`;
const LegendIconLine = styled.div`
  height: 2px;
  width: 16px;
  background-color: ${({ color, theme }) => color || theme.color.gray6};
`;
const LegendLabel = styled.div`
  flex: auto;
  color: ${({ theme }) => theme.color.gray8};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
const LegendValue = styled.div`
  flex: auto;
  color: ${({ theme }) => theme.color.gray9};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  text-align: right;
  margin-left: 8px;
  white-space: nowrap;
`;
export {
  LegendIcon,
  LegendIconCircle,
  LegendIconLine,
  LegendItemWrapper,
  LegendLabel,
  LegendValue
};
